<a href="https://dollarflightclub.com" target="_blank">
    <div class="signup-logo">
        <img src="/assets/images/DFC-logo.webp" alt="Dollar Flight Club Logo" class="app-logo-normal">
        <img *ngIf="partnerLogoUrl" [src]="partnerLogoUrl" alt="Partner Logo" class="partner-logo">
    </div>
</a>
<div class="grid container">
    <div class="sm:col-12 md:col-6 content">
        <div class="content-wrapper">
            <h2 class="text-4xl mb-3">Add your phone number.</h2>
            <p class="text-lg">Add your phone number and we'll text you if we find a deal to your dream destination so
                you don't miss it in a crowded inbox.</p>

            <form class="p-fluid" [formGroup]="phoneForm" (ngSubmit)="submit()">
                <div class="p-field search-bar-container">
                <span class=p-input-icon-right>
                    <p-inputMask
                        mask="(999) 999-9999"
                        unmask="true"
                        formControlName="phone"
                        styleClass="phone-input"
                        placeholder="(555) 555-5555"
                        type="tel"
                        (keydown.enter)="submit()"
                        (click)="moveCursorToStart()"
                        [class.p-invalid]="
    phoneForm.get('phone')?.invalid &&
    phoneForm.get('phone')?.touched
  "
                    ></p-inputMask>
                <i class="pi pi-phone"></i>
            </span>
                </div>
                <div class="flex align-items-start gap-2 mb-3">
                    <p-checkbox formControlName="smsConsent" [binary]="true" inputId="smsConsent"></p-checkbox>
                    <label for="smsConsent" class="text-xs text-color-secondary line-height-3">
                        By providing my phone number and enabling SMS notifications, I agree to receive recurring
                        automated text messages from Dollar Flight Club regarding my account, payment recovery, and
                        flight deal alerts. Message frequency varies. Message and data rates may apply. Reply STOP to
                        unsubscribe or HELP for help. Consent is not a condition of purchase. See our
                        <a href="https://dollarflightclub.com/terms-of-use" target="_blank" rel="noopener">Terms of Use</a>
                        and
                        <a href="https://dollarflightclub.com/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>.
                    </label>
                </div>
                <small class="p-error block mb-3"
                       *ngIf="phoneForm.get('smsConsent').invalid && phoneForm.get('smsConsent').touched">
                    Please agree to receive text messages to save your phone number.
                </small>
                <button
                    pButton type="submit"
                    class="p-button-primary next-btn"
                    (click)="submit()"
                   >
                    <span class="button-content">
                        <span *ngIf="!loading">Next &rarr;</span>
                        <span *ngIf="loading" class="loading-spinner">
                            <i class="pi pi-spinner pi-spin"></i>
                        </span>
                    </span>
                </button>
            </form>
        </div>
    </div>

    <div class="col-12 md:col-6 image-container pr-6">
        <div class="signup-image">
            <img
                appResponsiveImage="signup/PhonePage"
                [sizes]="'(min-width: 1580px) 570px, calc(33.33vw + 50px)'"
                alt="Phone Image"
                class="w-full h-auto"/>
        </div>
    </div>
</div>
